import { Fragment, useState, useEffect } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { AiOutlineSave } from "react-icons/ai";
import { ImSpinner8 } from "react-icons/im";

export default function ConfirmSaveModal({ setOpenConfirmModal, openConfirmModal, handleSubmit,action }) {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!openConfirmModal) {
      setLoading(false);
    }
  }, [openConfirmModal]);
  let modalTitle, modalMessage;
  switch (action) {
    case 'saveForNow':
      modalTitle = "Save Changes For Now";
      modalMessage = "Your changes will be saved but not submitted for review.";
      break;
    case 'submit':
      modalTitle = "Submit Changes";
      modalMessage = "Your changes will be visible on this project metadata page.";
      break;
    case 'resubmit':
      modalTitle = "Resubmit Changes";
      modalMessage = "Your changes will be resubmitted for review.";
      break;
    default:
      modalTitle = "Save Changes";
      modalMessage = "Please confirm to save your changes.";
      break;
  }

  return (
    <Transition.Root show={openConfirmModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={() => {
        setLoading(false);
        setOpenConfirmModal(false);
      }}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-hidden">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6 dark:bg-gray-900">
                <div className="sm:flex sm:items-start">
                  <div className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10 dark:bg-green-200">
                    <AiOutlineSave className="h-6 w-6 text-green-600" aria-hidden="true" />
                  </div>
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                    <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-white" id="modal-title">
                    {modalTitle}
                    </h3>
                    <div className="mt-2">
                      <p className="text-sm text-gray-500 dark:text-gray-400">
                      {modalMessage}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                  <button
                    onClick={() => {
                      setLoading(true);
                      handleSubmit();
                    }}
                    data-cy="confirm"
                    disabled={loading}
                    type="button"
                    className="inline-flex md:w-20 w-full justify-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 sm:ml-3"
                  >
                    {loading ? (
                      <ImSpinner8 className="w-5 h-5 text-gray-50 animate-spin dark:text-gray-600" />
                    ) : (
                      "Confirm"
                    )}
                  </button>
                  <button
                    onClick={() => {
                      setLoading(false);
                      setOpenConfirmModal(false);
                    }}
                    type="button"
                    className="mt-3 inline-flex md:w-20 w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm hover:bg-gray-50 sm:mt-0 dark:border dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 dark:hover:text-white dark:hover:bg-gray-700"
                  >
                    Cancel
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
